.chart {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  padding: 0;
  margin: 0;
  list-style: none;
}

.row {
  display: block;
}

.hit {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: var(--space-1) var(--space-3);
  width: 100%;
  padding: var(--space-2);
  border: none;
  border-radius: var(--radius-sm);
  background: none;
  text-align: left;
  cursor: default;
}

button.hit {
  cursor: pointer;
}

button.hit:hover,
button.hit[aria-expanded="true"] {
  background: var(--surface-sunken);
}

/* Indented under the bar it belongs to, so a long list still reads as part of
   that row rather than as the next one. */
.panel {
  padding: var(--space-2) 0 var(--space-3) var(--space-2);
  margin-left: var(--space-2);
  border-left: 2px solid var(--border);
}

.label {
  font-size: var(--text-sm);
  color: var(--text-primary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.value {
  font-size: var(--text-sm);
  color: var(--text-secondary);
}

.track {
  grid-column: 1 / -1;
  height: var(--space-2);
  border-radius: var(--radius-full);
  background: var(--surface-sunken);
  overflow: hidden;
}

.bar {
  display: block;
  height: 100%;
  border-radius: var(--radius-full);
  transition: width var(--duration-base) var(--ease-out);
}

.empty {
  padding: var(--space-4) 0;
  font-size: var(--text-sm);
  color: var(--text-muted);
}
